<cxone-modal [headerTitle]="headerTitle" (dismissed)="cancel()" [allowClose]="true" (closed)="save()"
    [saveDisabled]="!isDefinitionSelected" [cancelLabel]="cancelLabel" [saveLabel]="recalculateLabel"
    *ngIf="isLocalizationSectionLoaded">
    <cxone-embedded-messages class="embedded-message" messageType="system-info" [messageData]="inProgressMetricsInfo" id="system-info" *ngIf="inProgressMetricList.length > 0"></cxone-embedded-messages>
    <cxone-embedded-messages class="embedded-message" messageType="system-warning" [messageData]="warningMessage" id="system-warning" *ngIf="showWarningMsg"></cxone-embedded-messages>
    <label class="label-field allCaps" cvLocalizedText langSection="ETL_Recalculation_Modal" langKey="Date_Range">Date
        Range</label>
    <span class="question-icon" id="infoDateRangeIcon" container="body">
        <svg class="icon-16" [popover]="popoverTemplate" containerClass="cxone-popover" triggers="mouseenter:mouseleave"
            placement="right">
            <use href="../App_Themes/CXone/icons/question.svg#question"></use>
        </svg>
    </span>
    <div class="date-range-selector">
        <cxone-date-range-dropdown [dateRangeDropdownContainer]="'.modal-body-wrapper'"
            [filterOptions]="['CustomRange']" [dateRange]="dateRangeObj"
            [optionsWhereToShowDateOnDropdown]="['CustomRange']" [customRangeMinAndMax]="customDateRange"
            (dateRangeChanged)="onDateRangeChanged($event)" id="date-range-dropdown">
        </cxone-date-range-dropdown>
    </div>
    <div class="recalculation-grid-container">
        <cxone-omnibar class="search-input" [itemCountLabel]="metricsLabel" [isFilterable]="false"
            [searchPlaceholderText]="searchPlaceholderText" (searchQueryChange)="onSearchCriteriaChange($event)"
            [searchQuery]="searchInput">
        </cxone-omnibar>
        <cxone-grid class="content-container" [gridOptions]="metricsGridOptions"
            *ngIf="isLocalizationSectionLoaded"></cxone-grid>
    </div>
</cxone-modal>
<ng-template #popoverTemplate>
    <div class="popover-wrapper">
        <div class="message">{{dateRangeInfoMsg}}</div>
    </div>
</ng-template>